export const AccountContent = {
  // Page title
  title: 'Account',

  // Profile section
  profile: {
    name: 'Name',
    email: 'Email',
    role: 'Role',
    memberSince: 'Member Since',
    unknownName: 'Unknown',
  },

  // Sign out button
  signOut: {
    label: 'Sign Out',
    ariaLabel: 'Sign out of your account',
    confirmation: {
      title: 'Sign Out',
      description: 'Are you sure you want to sign out of your account?',
      cancel: 'Cancel',
      confirm: 'Sign Out',
    },
  },

  // Feedback section
  feedback: {
    title: 'Feedback',
    description: 'Want to make the app better?',
    form: {
      rating: {
        label: 'How would you rate your experience?',
      },
      message: {
        label: 'Message',
        placeholder: 'Tell us more about your experience...',
        helperText: 'Your feedback helps us improve the app',
      },
      isBug: {
        label: 'This is a bug/issue I found',
      },
      submit: {
        label: 'Submit Feedback',
        submitting: 'Submitting...',
        success: 'Thank you! Your feedback has been submitted.',
        error: 'Failed to submit feedback. Please try again.',
      },
    },
  },
} as const;

